<div>
    <button (click)="editOrCreate('0ms', '0ms',null, 'create')" class="register-btn" matFab aria-label="Novo Produto" matTooltip="Novo Produto">
        <mat-icon>add</mat-icon>
    </button>

    @if(loading){
    <div class="page-loader">
        <mat-spinner></mat-spinner>
    </div>
    }@else{
        @if (kits.length === 0) {
            <div class="empty-state">
                <mat-icon>inventory_2</mat-icon>
                <h3>Nenhum produto encontrado</h3>
                <p>Cadastre novos produtos para começar.</p>
            </div>
        }@else {
            <div class="products-grid">
                @for (kit of kits; track $index) {
                    <mat-card class="product-card" [class.expanded]="expandedCards[$index]" appearance="outlined">
                        <mat-card-header class="card-header">
                            <div class="header-content">
                                <div class="title-section">
                                    <mat-card-title>{{kit.titulo}}</mat-card-title>
                                    <mat-card-subtitle>{{kit.subtitulo}}</mat-card-subtitle>
                                </div>
                                <div class="header-actions">
                                    <button mat-icon-button color="primary" (click)="editOrCreate('0ms', '0ms', kit, 'edit')" class="edit-icon" matTooltip="Editar">
                                        <mat-icon>edit</mat-icon>
                                    </button>
                                    <div class="toggle-switch" [class.active]="kit.status === true" (click)="toggleProductStatus(kit)" [matTooltip]="kit.status ? 'Inativar' : 'Ativar'">
                                    <div class="toggle-slider">
                                        <div class="toggle-thumb">{{kit.status ? 'on' : 'off'}}</div>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </mat-card-header>

                        <div class="card-image-container">
                            <img mat-card-image [src]="kit.imagem" alt="{{kit.titulo}}" class="product-image">
                            <div class="image-overlay"></div>
                        </div>

                        <mat-card-content class="card-content">
                            <div class="description-section detail-item">
                                <div class="detail-header">
                                    <h4>{{kit.tipo_kit}}</h4>
                                    <h4>Estoque<span class="detail-content"> - {{kit.estoque}}</span></h4>
                                </div>
                            </div>

                            <div class="description-section detail-item">
                                <div class="detail-header">
                                    <h4>Descrição resumo</h4>
                                </div>
                                <div class="detail-content">
                                    <p [innerHTML]="kit.descricao_resumo"></p>
                                </div>
                            </div>

                            <!-- Conteúdo expansível -->
                            <div class="expandable-content" [class.expanded]="expandedCards[$index]">
                              <div class="description-section detail-item">
                                <div class="detail-header">
                                    <h4>Descrição completa</h4>
                                </div>
                                <div class="detail-content">
                                    <p [innerHTML]="kit.descricao"></p>
                                </div>
                            </div>

                              <div class="description-section detail-item">
                                    <div class="detail-header">
                                        <h4>Bula</h4>
                                    </div>
                                    <div class="detail-content">
                                        <a href="{{kit.bula?.[0]?.link}}" target="_blank">{{kit.bula?.[0]?.link || 'N/A'}}</a>
                                    </div>
                                </div>

                                <div class="details-section">
                                    <div class="detail-item">
                                        <div class="detail-header flex">
                                            <mat-icon>medical_services</mat-icon>
                                            <h4>Especialidades elegíveis</h4>
                                        </div>
                                        <div class="detail-content">
                                            <div class="tags-container">
                                                @for (especialidade of kit.especialidades_elegiveis; track $index) {
                                                    <span class="tag">{{especialidade}}</span>
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <div class="detail-item">
                                        <div class="detail-header flex">
                                            <mat-icon>location_on</mat-icon>
                                            <h4>Regiões elegíveis</h4>
                                        </div>
                                        <div class="detail-content">
                                            <div class="tags-container">
                                                @for (regiao of kit.regioes_elegiveis; track $index) {
                                                    <span class="tag">{{regiao}}</span>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </mat-card-content>

                        <!-- Botão Exibir Tudo -->
                            <div class="expand-section">
                                <button mat-button style="color: #FFFFFF" color="primary" class="expand-btn" (click)="toggleExpand($index)">
                                    <mat-icon>{{expandedCards[$index] ? 'expand_less' : 'expand_more'}}</mat-icon>
                                    {{expandedCards[$index] ? 'RECOLHER' : 'EXIBIR TUDO'}}
                                </button>
                            </div>
                    </mat-card>
                }
            </div>
        }
    }
</div>
